import React from "react";
import logoImg from "../assets/logos/logo_holistique_mini.webp";
import "./Slogan.css";


export default function Slogan() {
  return (
    <section className="slogan-section">
      <div className="slogan-content">
        <h1 className="slogan-title">Conectamos medicos con pacientes que buscan resultados reales. </h1>
      </div>
      <img src={logoImg} alt="Holistique_logo" />
    </section>
  );
}   